// @flow

import React from 'react';
import { Link } from 'react-router-dom';
import { css, cx } from 'react-emotion';
import { fonts, colors, components, typography } from '@peachjar/components';

const { ProximaNova } = fonts;
const { paragraph } = typography;
const { prussian } = colors;
const { ButtonPrimaryLarge } = components.Buttons;

const styles = {
  wrapper: css({
    fontFamily: ProximaNova,
    height: '291px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  }),
  innerWrapper: css({
    width: '382px',
    height: '145px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'column',
  }),
  centered: css({
    textAlign: 'center',
  }),
};

type Props = {|
  +onGetStarted: () => void,
|};

const ProposalBox = ({ onGetStarted }: Props) => (
  <div className={styles.wrapper}>
    <div className={styles.innerWrapper}>
      <p className={cx(paragraph, styles.centered)}>
        {
          "Get a custom proposal with pricing at a bulk rate that's tailored to your district."
        }
      </p>

      <ButtonPrimaryLarge
        onClick={onGetStarted}
        data-testid="submit-nextPageRFP"
      >
        Request Proposal
      </ButtonPrimaryLarge>
    </div>
  </div>
);

export default ProposalBox;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/ProposalBox.jsx